import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import RestService from "./../../Restservice";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Technical from "./Technical";
import Fundamental from "./Fundamental";
import AllScan from "./AllScan";
import Chart from "./Chart";
import Indicators from "./Indicators";
import FANDODATA from "./FANDODATA";
import BulkDeals from "./BulkDeals";
import BlockDeals from "./BlockDeals";
import EventData from "./EventData";
import PeersData from "./PeersData";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography variant="caption">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function ScrollableTabsButtonAuto(props) {
  const symbol = props.symbol;
  let defaultValue = 1;
  if (symbol.includes("about-")) {
    defaultValue = "-peers-data";
  }
  if (symbol.includes("-share-price")) {
    defaultValue = "-share-price";
  }
  if (symbol.includes("-market-capitalization")) {
    defaultValue = "-market-capitalization";
  }
  if (symbol.includes("-screener")) {
    defaultValue = "-screener";
  }
  if (symbol.includes("-technical-analysis")) {
    defaultValue = "-technical-analysis";
  }
  if (symbol.includes("-option-chain")) {
    defaultValue = "-option-chain";
  }
  if (symbol.includes("-events-data")) {
    defaultValue = "-events-data";
  }
  if (symbol.includes("-peers-data")) {
    defaultValue = "-peers-data";
  }
  if (symbol.includes("-block-deals")) {
    defaultValue = "-block-deals";
  }
  if (symbol.includes("-bulk-deals")) {
    defaultValue = "-bulk-deals";
  }

  const [value, setValue] = React.useState(defaultValue);
  const [resultdata, setresultdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";
  const history = useHistory();

  const correction = {
    "about-": "",
    "-share-price": "",
    "-market-capitalization": "",
    "-screener": "",
    "-technical-analysis": "",
    "-option-chain": "",
    "-events-data": "",
    "-peers-data": "",
    "-block-deals": "",
    "-bulk-deals": "",
  };
  React.useEffect(() => {
    if (symbol) {
      setresultdata([]);
      setLoading(true);
      RestService.gethStockScanData(
        function (res, symbol) {
          const response = JSON.parse(res);
          setresultdata(response.data);
          setLoading(false);
        },
        symbol,
        mobile,
        web_token
      );
    }
  }, [symbol, mobile, web_token]);

  React.useEffect(() => {}, [symbol]);
  const ShowFAO = props?.fnoData?.allDate?.length;

  const handleChange = (event, newValue) => {
    let newSymbol = symbol;
    Object.keys(correction).forEach((key) => {
      newSymbol = newSymbol.replace(key, correction[key]);
    });

    if (newValue === "about-") {
      history.push(`/stocks/about-${newSymbol}`);
    }
    if (newValue === "-share-price") {
      history.push(`/stocks/${newSymbol}-share-price`);
    }
    if (newValue === "-market-capitalization") {
      history.push(`/stocks/${newSymbol}-market-capitalization`);
    }
    if (newValue === "-screener") {
      history.push(`/stocks/${newSymbol}-screener`);
    }
    if (newValue === "-chart") {
      window.open(
        `https://finance.yahoo.com/chart/${newSymbol}.NS`,
        "sharer",
        "toolbar=0,status=0,width=auto,height=325"
      );
    }
    if (newValue === "-news") {
      window.open(
        `https://www.google.com/search?q=${newSymbol}`,
        "sharer",
        "toolbar=0,status=0,width=auto,height=325"
      );
    }
    if (newValue === "-technical-analysis") {
      history.push(`/stocks/${newSymbol}-technical-analysis`);
    }
    if (newValue === "-option-chain") {
      history.push(`/stocks/${newSymbol}-option-chain`);
    }
    if (newValue === "-events-data") {
      history.push(`/stocks/${newSymbol}-events-data`);
    }
    if (newValue === "-peers-data") {
      history.push(`/stocks/${newSymbol}-peers-data`);
    }
    if (newValue === "-block-deals") {
      history.push(`/stocks/${newSymbol}-block-deals`);
    }
    if (newValue === "-bulk-deals") {
      history.push(`/stocks/${newSymbol}-bulk-deals`);
    }
    setValue(newValue);
  };

  return (
    <>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label="Info" value="about-" />
          <Tab label="Technical" value="-share-price" />
          <Tab label="Fundamental" value="-market-capitalization" />
          <Tab label="All Scan" value="-screener" />
          <Tab label="Chart" value="-chart" />
          <Tab label="News" value="-news" />
          <Tab label="Indicators" value="-technical-analysis" />
          {ShowFAO > 0 && <Tab label="F&O" value="-option-chain" />}
          <Tab label="Events" value="-events-data" />
          <Tab label="Peers" value="-peers-data" />
          <Tab label="Block Deals" value="-block-deals" />
          <Tab label="Bulk Deals" value="-bulk-deals" />
        </Tabs>
      </AppBar>
      <TabPanel className="customtabpanel" value={value} index={"about-"}>
        <div>{props?.value?.stock_info}</div>
      </TabPanel>
      <TabPanel className="customtabpanel" value={value} index={"-share-price"}>
        <Technical techdata={props.value ? props.value : ""} />
      </TabPanel>
      <TabPanel
        className="customtabpanel"
        value={value}
        index={"-market-capitalization"}
      >
        <Fundamental
          fundata={props.funvalue ? props.funvalue : ""}
          funXDetails={props?.funXDetails}
        />
      </TabPanel>
      <TabPanel className="customtabpanel" value={value} index={"-screener"}>
        {loading ? (
          <div className="spinnerContainer">
            Please Wait
            <i className="fa fa-spinner fa-spin addCustomSpin"></i>
          </div>
        ) : (
          <AllScan
            autoSignalBear={resultdata?.autoSignalBear}
            autoSignalBull={resultdata?.autoSignalBull}
            scrSignalBear={resultdata?.scrSignalBear}
            scrSignalBull={resultdata?.scrSignalBull}
            showType={resultdata?.showType}
          />
        )}
      </TabPanel>
      <TabPanel className="customtabpanel" value={value} index={"-chart"}>
        <Chart />
      </TabPanel>
      <TabPanel className="customtabpanel" value={value} index={"-news"}>
        {props.newsLink && props.newsLink}
      </TabPanel>
      <TabPanel
        className="customtabpanel"
        value={value}
        index={"-technical-analysis"}
      >
        <Indicators
          indicators={props?.indicators}
          showType={resultdata?.showType}
          showIndicators={props?.showIndicators}
          techdata={props.value ? props.value : ""}
        />
      </TabPanel>
      {ShowFAO > 0 && (
        <TabPanel
          className="customtabpanel"
          value={value}
          index={"-option-chain"}
        >
          <FANDODATA symbol={symbol} fnoData={props?.fnoData} />
        </TabPanel>
      )}
      <TabPanel className="customtabpanel" value={value} index={"-events-data"}>
        <EventData eventData={resultdata?.eventData} />
      </TabPanel>
      <TabPanel className="customtabpanel" value={value} index={"-peers-data"}>
        <PeersData
          peersData={resultdata?.peersData}
          setColumn={resultdata?.setColumn}
        />
      </TabPanel>
      <TabPanel className="customtabpanel" value={value} index={"block-deals"}>
        <BlockDeals blockData={resultdata?.blockData} />
      </TabPanel>
      <TabPanel className="customtabpanel" value={value} index={"-bulk-deals"}>
        <BulkDeals bulkData={resultdata?.bulkData} />
      </TabPanel>
    </>
  );
}
